import PersonaListIsFullModal from './PersonaListIsFullModal';

export default PersonaListIsFullModal;
